import { useState, useEffect, useRef } from "react"
import { RiDeleteBin5Line } from "react-icons/ri"
import { BiSolidEdit } from "react-icons/bi"
import { FaCopy, FaFileCsv, FaFileExcel, FaFilePdf } from "react-icons/fa"
import { PiSortAscendingLight, PiSortDescendingLight } from "react-icons/pi"
import * as XLSX from "xlsx"
import jsPDF from "jspdf"
import "jspdf-autotable"
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


// import { BaseUrl } from "../App"
function Emlsms() {
  const [activeTab, setActiveTab] = useState("EMAIL")
  
  const [emailData, setEmailData] = useState([
    {
      id: 1,
      subject: "Meeting Reminder",
      message: "Don't forget about our meeting tomorrow",
      attachment: "agenda.pdf",
      date: "2023-05-01",
    },
    {
      id: 2,
      subject: "Project Update",
      message: "Here's the latest update on our project",
      attachment: "report.docx",
      date: "2023-05-02",
    },
    {
      id: 3,
      subject: "Holiday Notice",
      message: "The office will be closed next Monday",
      attachment: "project.docx",
      date: "2023-05-03",
    },
    {
      id: 4,
      subject: "New Policy",
      message: "Please review the new company policy",
      attachment: "policy.pdf",
      date: "2023-05-04",
    },
  ])
  const [smsData, setSmsData] = useState([
    { id: 1, message: "Hello, how are you?", date: "2023-05-01" },
    { id: 2, message: "Meeting at 3 PM", date: "2023-05-02" },
    { id: 3, message: "Don't forget to submit the report", date: "2023-05-03" },
  ])

  const [formData, setFormData] = useState({
    id: null,
    subject: "",
    message: "",
    attachment: "",
    date: "",
  })

  const [searchQuery, setSearchQuery] = useState("")
  const [sortedTable, setSortedTable] = useState([])
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" })
  const [entriesPerPage, setEntriesPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  const tabs = ["EMAIL", "SMS"]

  useEffect(() => {
    setSortedTable(activeTab === "EMAIL" ? emailData : smsData)
  }, [activeTab, emailData, smsData])

  const handleSort = (column) => {
    let direction = "asc"
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc"
    }
    setSortConfig({ key: column, direction })

    const sortedData = [...sortedTable].sort((a, b) => {
      if (!a || !b) return 0
      const aValue = a[column] || ""
      const bValue = b[column] || ""
      if (aValue < bValue) return direction === "asc" ? -1 : 1
      if (aValue > bValue) return direction === "asc" ? 1 : -1
      return 0
    })

    setSortedTable(sortedData)
  }

  const getSortIcon = (column) => {
    if (sortConfig.key !== column) {
      return <PiSortAscendingLight className="text-gray-500" />
    }
    return sortConfig.direction === "asc" ? <PiSortAscendingLight /> : <PiSortDescendingLight />
  }

  const filteredData = sortedTable.filter((row) => {
    if (!row) return false
    if (activeTab === "EMAIL") {
      return (
        row.subject?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.message?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.attachment?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.date?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    } else {
      return (
        row.message?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.date?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    }
  })

  const startIndex = (currentPage - 1) * entriesPerPage
  const paginatedData =
    entriesPerPage === "All"
      ? filteredData
      : filteredData.slice(
          startIndex,
          startIndex + (typeof entriesPerPage === "number" ? entriesPerPage : filteredData.length),
        )

  const totalPages = Math.ceil(
    filteredData.length / (typeof entriesPerPage === "number" ? entriesPerPage : filteredData.length),
  )

  const handleSearch = (e) => setSearchQuery(e.target.value)

  const handleEntriesChange = (e) => {
    const value = e.target.value
    setEntriesPerPage(value === "All" ? "All" : Number.parseInt(value, 10))
    setCurrentPage(1)
  }

  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1))
  const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages))
  const handlePageChange = (page) => setCurrentPage(page)

  const handleSubmit = (e) => {
    e.preventDefault()
    let newData
    if (activeTab === "EMAIL") {
      newData = {
        id: formData.id || emailData.length + 1,
        subject: formData.subject.trim(),
        message: formData.message.trim(),
        attachment: formData.attachment.trim(),
        date: formData.date,
      }
    } else {
      newData = {
        id: formData.id || smsData.length + 1,
        message: formData.message.trim(),
        date: formData.date,
      }
    }

    if (formData.id) {
      if (activeTab === "EMAIL") {
        setEmailData(emailData.map((row) => (row.id === formData.id ? newData : row)))
      } else {
        setSmsData(smsData.map((row) => (row.id === formData.id ? newData : row)))
      }
    } else {
      if (activeTab === "EMAIL") {
        setEmailData([...emailData, newData])
      } else {
        setSmsData([...smsData, newData])
      }
    }

    setFormData({
      id: null,
      subject: "",
      message: "",
      attachment: "",
      date: "",
    })
  }

  const handleDelete = (id) => {
    if (activeTab === "EMAIL") {
      setEmailData(emailData.filter((row) => row.id !== id))
    } else {
      setSmsData(smsData.filter((row) => row.id !== id))
    }
  }

  const handleEdit = (id) => {
    const row = sortedTable.find((row) => row.id === id)
    if (activeTab === "EMAIL") {
      setFormData({
        id: row.id,
        subject: row.subject,
        message: row.message,
        attachment: row.attachment,
        date: row.date,
      })
    } else {
      setFormData({
        id: row.id,
        subject: "",
        message: row.message,
        attachment: "",
        date: row.date,
      })
    }
  }

  const tableRef = useRef(null)

  const copyToClipboard = () => {
    const elTable = tableRef.current
    let range, sel

    // Ensure that range and selection are supported by the browsers
    if (document.createRange && window.getSelection) {
      range = document.createRange()
      sel = window.getSelection()
      // Unselect any element in the document
      sel.removeAllRanges()

      try {
        range.selectNodeContents(elTable)
        sel.addRange(range)
      } catch (e) {
        range.selectNode(elTable)
        sel.addRange(range)
      }

      // Copy the selection to clipboard
      document.execCommand("copy")
    }

    // Clear the selection
    sel.removeAllRanges()

    alert("Table copied to clipboard")
  }

  const exportToCSV = () => {
    const headers = activeTab === "EMAIL" ? ["Subject", "Message", "Attachment", "Date"] : ["Message", "Date"]

    const csvContent = [
      headers.join(","),
      ...sortedTable.map((row) => {
        if (activeTab === "EMAIL") {
          return `"${row.subject}","${row.message}","${row.attachment}","${row.date}"`
        } else {
          return `"${row.message}","${row.date}"`
        }
      }),
    ].join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const link = document.createElement("a")
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", `${activeTab.toLowerCase()}_data.csv`)
      link.style.visibility = "hidden"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  const exportToExcel = () => {
    // Prepare the data
    const data = sortedTable.map((row) => {
      if (activeTab === "EMAIL") {
        return {
          Subject: row.subject,
          Message: row.message,
          Attachment: row.attachment,
          Date: row.date,
        }
      } else {
        return {
          Message: row.message,
          Date: row.date,
        }
      }
    })

    // Create a new workbook and worksheet
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.json_to_sheet(data)

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1")

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, `${activeTab.toLowerCase()}_data.xlsx`)
  }

  const exportToPDF = () => {
    const doc = new jsPDF()
    const tableColumn = activeTab === "EMAIL" ? ["Subject", "Message", "Attachment", "Date"] : ["Message", "Date"]
    const tableRows = sortedTable.map((row) => {
      return activeTab === "EMAIL" ? [row.subject, row.message, row.attachment, row.date] : [row.message, row.date]
    })

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
    })

    doc.save(`${activeTab.toLowerCase()}_data.pdf`)
  }

  return (
    
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="text-2xl font-bold p-4">
        <span>Guest Customers</span>
      </div>

      <div className="flex flex-nowrap justify-between border-b sm:border-b-4 md:border-b-8 border-gray-300 pb-4 mb-6 overflow-x-auto">
        <div className="flex flex-row w-full gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`flex-1 text-center px-2 sm:px-4 py-2 text-nowrap text-xs sm:text-sm font-medium rounded-lg transition-colors duration-300 ease-in-out ${
                activeTab === tab
                  ? "bg-blue-500 border-b-4 border-blue-500 font-semibold text-white"
                  : "border-b-4 border-transparent text-gray-600 hover:text-blue-400 hover:border-blue-300 bg-slate-50"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
        <div className="flex flex-col sm:flex-row sm:gap-11 sm:items-center mb-4 sm:mb-0 w-full sm:w-auto">
          <input
            type="text"
            placeholder={`Search ${activeTab.toLowerCase()}...`}
            value={searchQuery}
            onChange={handleSearch}
            className="p-3 w-full sm:w-96 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
          />
          <div className="flex flex-wrap gap-2 sm:gap-4 mt-4 sm:mt-0">
            <button
              onClick={copyToClipboard}
              className="bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-green-600 hover:to-green-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
            >
              <FaCopy className="text-2xl" />
              Copy
            </button>
            <button
              onClick={exportToCSV}
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-yellow-600 hover:to-yellow-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
            >
              <FaFileCsv className="text-2xl" />
              CSV
            </button>
            <button
              onClick={exportToExcel}
              className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
            >
              <FaFileExcel className="text-2xl" />
              Excel
            </button>
            <button
              onClick={exportToPDF}
              className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-red-600 hover:to-red-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
            >
              <FaFilePdf className="text-2xl" />
              PDF
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-4 sm:mt-0">
          <span>show</span>
          <select
            value={entriesPerPage}
            onChange={handleEntriesChange}
            className="p-3 m-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value="All">All</option>
          </select>
          <span>entries</span>
        </div>
      </div>

      {/* Desktop view */}
      <div className="hidden sm:block overflow-x-auto">
        <table ref={tableRef} className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg">
          <thead className="bg-blue-100 text-left">
            <tr>
              <th className="px-4 py-2 border-b">#</th>
              {activeTab === "EMAIL" ? (
                <>
                  <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("subject")}>
                    <div className="flex items-center gap-2">Subject {getSortIcon("subject")}</div>
                  </th>
                  <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("message")}>
                    <div className="flex items-center gap-2">Message {getSortIcon("message")}</div>
                  </th>
                  <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("attachment")}>
                    <div className="flex items-center gap-2">Attachment {getSortIcon("attachment")}</div>
                  </th>
                  <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("date")}>
                    <div className="flex items-center gap-2">Date {getSortIcon("date")}</div>
                  </th>
                </>
              ) : (
                <>
                  <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("message")}>
                    <div className="flex items-center gap-2">Message {getSortIcon("message")}</div>
                  </th>
                  <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("date")}>
                    <div className="flex items-center gap-2">Date {getSortIcon("date")}</div>
                  </th>
                </>
              )}
              <th className="px-4 py-2 border-b">Actions</th>
            </tr>
          </thead>
          <tbody>
            {sortedTable.length > 0 ? (
              paginatedData.map((row, index) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border-b">{index + 1 + startIndex}</td>
                  {activeTab === "EMAIL" ? (
                    <>
                      <td className="px-4 py-2 border-b">{row.subject}</td>
                      <td className="px-4 py-2 border-b">{row.message}</td>
                      <td className="px-4 py-2 border-b">{row.attachment}</td>
                      <td className="px-4 py-2 border-b">{row.date}</td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2 border-b">{row.message}</td>
                      <td className="px-4 py-2 border-b">{row.date}</td>
                    </>
                  )}
                  <td className="px-4 py-2 border-b">
                    <button onClick={() => handleEdit(row.id)} className="text-green-700 hover:text-green-900 mr-2">
                      <BiSolidEdit className="text-2xl" />
                    </button>
                    <button onClick={() => handleDelete(row.id)} className="text-red-500 hover:text-red-600">
                      <RiDeleteBin5Line className="text-2xl" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={activeTab === "EMAIL" ? 6 : 4} className="px-4 py-2 text-center text-gray-500 border-b">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile view */}
      <div className="sm:hidden">
        {sortedTable.length > 0 ? (
          paginatedData.map((row, index) => (
            <div key={row.id} className="bg-white rounded-lg shadow-md p-4 mb-4">
              <div className="flex justify-between items-center mb-2">
                <span className="font-semibold">#{index + 1 + startIndex}</span>
                <div>
                  <button onClick={() => handleEdit(row.id)} className="text-green-700 hover:text-green-900 mr-2">
                    <BiSolidEdit className="text-2xl" />
                  </button>
                  <button onClick={() => handleDelete(row.id)} className="text-red-500 hover:text-red-600">
                    <RiDeleteBin5Line className="text-2xl" />
                  </button>
                </div>
              </div>
              {activeTab === "EMAIL" ? (
                <>
                  <p>
                    <strong>Subject:</strong> {row.subject}
                  </p>
                  <p>
                    <strong>Message:</strong> {row.message}
                  </p>
                  <p>
                    <strong>Attachment:</strong> {row.attachment}
                  </p>
                  <p>
                    <strong>Date:</strong> {row.date}
                  </p>
                </>
              ) : (
                <>
                  <p>
                    <strong>Message:</strong> {row.message}
                  </p>
                  <p>
                    <strong>Date:</strong> {row.date}
                  </p>
                </>
              )}
            </div>
          ))
        ) : (
          <div className="text-center text-gray-500">No data found</div>
        )}
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
        <div className="text-sm text-gray-600 mb-4 sm:mb-0">
          <span>Showing </span>
          <span>{startIndex + 1}</span>
          <span> to </span>
          <span>{Math.min(startIndex + entriesPerPage, filteredData.length)}</span>
          <span> of </span>
          <span>{filteredData.length}</span>
          <span> entries</span>
        </div>

        {entriesPerPage !== "All" && (
          <div className="flex items-center">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
            >
              Previous
            </button>
            {[...Array(totalPages).keys()].map((page) => (
              <button
                key={page + 1}
                onClick={() => handlePageChange(page + 1)}
                className={`px-4 py-2 border ${
                  currentPage === page + 1 ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-gray-300"
                }`}
              >
                {page + 1}
              </button>
            ))}
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
    </div>
  )
}

export default Emlsms;



// import { RiDeleteBin5Line } from "react-icons/ri";
// import { BiSolidEdit } from 'react-icons/bi';
// import { FaCopy, FaFileCsv, FaFileExcel, FaFilePdf } from 'react-icons/fa';
// import { PiSortAscendingLight } from "react-icons/pi";
// import { PiSortDescendingLight } from "react-icons/pi";
// function Emlsms() {
//   const [formData, setFormData] = useState({
//     id: null,
//     name: "",
//     email: "",
//     mobile: "",
//   });

//   const [searchQuery, setSearchQuery] = useState("");
//   const [tableData, setTableData] = useState([
//     { id: 1, name: "Maitri1", email: "abc1@example.com", mobile: "9876543210" },
//     { id: 2, name: "Man2", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 3, name: "Man", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 4, name: "Man", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 5, name: "Man", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 6, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 7, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 8, name: "Abc", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 9, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 10, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 11, name: "Maitri1", email: "abc1@example.com", mobile: "9876543210" },
//     { id: 12, name: "Man2", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 13, name: "zxy", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 14, name: "Man", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 15, name: "xyz", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 16, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 17, name: "cfv", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 18, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 19, name: "Hem", email: "ab@example.com", mobile: "9123456780" },
//     { id: 20, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 21, name: "Maitri1", email: "abc1@example.com", mobile: "9876543210" },
//     { id: 22, name: "Man2", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 23, name: "Man", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 24, name: "Man", email: "abc12@example.com", mobile: "1234567890" },
//     { id: 25, name: "abc", email: "ji@example.com", mobile: "1234567890" },
//     { id: 26, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 27, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 28, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//     { id: 29, name: "bxem", email: "ajk@example.com", mobile: "9123456780" },
//     { id: 30, name: "Hem", email: "abc123@example.com", mobile: "9123456780" },
//   ]);

//   const [sortedTable, setSortedTable] = useState(tableData); // This will hold the sorted data
//   const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });

//   // Sort function that updates sortedTable
//   const handleSort = (column) => {
//     let direction = 'asc';
//     if (sortConfig.key === column && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key: column, direction });

//     const sortedData = [...tableData].sort((a, b) => {
//       if (a[column] < b[column]) return direction === 'asc' ? -1 : 1;
//       if (a[column] > b[column]) return direction === 'asc' ? 1 : -1;
//       return 0;
//     });

//     setSortedTable(sortedData); // Update the sortedTable state
//   };

//   const getSortIcon = (column) => {
//     if (sortConfig.key !== column) {
//       return <PiSortAscendingLight className="text-gray-500" />;
//     }
//     return sortConfig.direction === 'asc' ? <PiSortAscendingLight /> : <PiSortDescendingLight />;
//   };

//   useEffect(() => {
//     setSortedTable(tableData); // Initialize sortedTable with tableData when component mounts
//   }, [tableData]);


//   const [entriesPerPage, setEntriesPerPage] = useState(10); // Number of entries per page
//   const [currentPage, setCurrentPage] = useState(1); // Current page number

//   // Filtered data based on search query
//   const filteredData = sortedTable.filter((row) =>
//     row.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     row.email.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // Paginated data based on the current page and entries per page
//   const startIndex = (currentPage - 1) * entriesPerPage;
//   const paginatedData = entriesPerPage === "All"
//     ? filteredData
//     : filteredData.slice(startIndex, startIndex + entriesPerPage);

//   const totalPages = Math.ceil(filteredData.length / entriesPerPage);

//   // Handle changes in the search query
//   const handleSearch = (e) => setSearchQuery(e.target.value);

//   // Handle changes in entries per page
//   const handleEntriesChange = (e) => {
//     setEntriesPerPage(e.target.value === "All" ? "All" : parseInt(e.target.value, 10));
//     setCurrentPage(1); // Reset to first page
//   };

//   // Pagination handlers
//   const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
//   const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
//   const handlePageChange = (page) => setCurrentPage(page);

//   const handleSubmit = (e) => {
//     e.preventDefault(); // Prevent the default form submission behavior

//     // Create new data object from the form
//     const newData = {
//       id: formData.id || tableData.length + 1, // Assign new ID if adding, else use the current ID for update
//       name: formData.name.trim(),
//       email: formData.email,
//       mobile: formData.mobile,

//     };

//     // If editing an existing entry, update that entry, else add a new one
//     if (formData.id) {
//       setTableData(tableData.map((row) =>
//         row.id === formData.id ? newData : row
//       ));
//     } else {
//       setTableData([...tableData, newData]);
//     }

//     // Reset form data for the next entry
//     setFormData({
//       id: null,
//       name: "",
//       email: "",
//       mobile: "",

//     });

//     // Show success message for a few seconds


//   };

//   // Handle deleting a staff entry
//   const handleDelete = (id) => {
//     setTableData(tableData.filter((row) => row.id !== id));
//   };

//   // Handle editing a staff entry
//   const handleEdit = (id) => {
//     // Find the staff entry by ID and populate the form with that data
//     const row = tableData.find((row) => row.id === id);
//     setFormData({
//       ...row,
//       name: row.name,
//       email: row.email,
//       mobile: row.mobile,


//     });
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-4">
//       <div className="text-2xl font-bold p-4">
//         <span>Guest Customers</span>
//       </div>

//       <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
//         <div className="flex flex-col sm:flex-row sm:gap-11 sm:items-center mb-4 sm:mb-0 w-full sm:w-auto">
//           <input
//             type="text"
//             placeholder="Search guest customer..."
//             value={searchQuery}
//             onChange={handleSearch}
//             className="p-3 w-full sm:w-96 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
//           />
//           <div className="flex flex-wrap gap-2 sm:gap-4 mt-4 sm:mt-0">
//             <button className="bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-green-600 hover:to-green-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2">
//               <FaCopy className="text-2xl" />
//               Copy
//             </button>
//             <button className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-yellow-600 hover:to-yellow-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2">
//               <FaFileCsv className="text-2xl" />
//               CSV
//             </button>
//             <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2">
//               <FaFileExcel className="text-2xl" />
//               Excel
//             </button>
//             <button className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold text-lg py-2 px-5 rounded-full shadow-lg hover:shadow-xl hover:from-red-600 hover:to-red-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2">
//               <FaFilePdf className="text-2xl" />
//               PDF
//             </button>
//           </div>
//         </div>

//         <div className="flex items-center gap-2 mt-4 sm:mt-0">
//           <span>show</span>
//           <select
//             value={entriesPerPage}
//             onChange={handleEntriesChange}
//             className="p-3 m-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value="All">All</option>
//           </select>
//           <span>entries</span>
//         </div>
//       </div>

//       <div className="overflow-x-auto">
//         <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg">
//           <thead className="bg-blue-100 text-left">
//             <tr>
//               <th className="px-4 py-2 border-b">#</th>
//               <th
//                 className="px-4 py-2 border-b cursor-pointer"
//                 onClick={() => handleSort('name')}
//               >
//                 <div className="flex items-center gap-2">
//                   Customer name {getSortIcon('name')}
//                 </div>
//               </th>
//               <th
//                 className="px-4 py-2 border-b cursor-pointer"
//                 onClick={() => handleSort('email')}
//               >
//                 <div className="flex items-center gap-2">
//                   Email Address {getSortIcon('email')}
//                 </div>
//               </th>
//               <th
//                 className="px-4 py-2 border-b cursor-pointer"
//                 onClick={() => handleSort('mobile')}
//               >
//                 <div className="flex items-center gap-2">
//                   Mobile No. {getSortIcon('mobile')}
//                 </div>
//               </th>
//               <th className="px-4 py-2 border-b">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {sortedTable.length > 0 ? (
//               paginatedData.map((row, index) => (
//                 <tr key={row.id} className="hover:bg-gray-50">
//                   <td className="px-4 py-2 border-b">{index + 1 + startIndex}</td>
//                   <td className="px-4 py-2 border-b">{row.name}</td>
//                   <td className="px-4 py-2 border-b">{row.email}</td>
//                   <td className="px-4 py-2 border-b">{row.mobile}</td>
//                   <td className="px-4 py-2 border-b">
//                     <button
//                       onClick={() => handleEdit(row.id)}
//                       className="text-green-700 hover:text-green-900"
//                     >
//                       <BiSolidEdit className="text-3xl" />
//                     </button>
//                     <button
//                       onClick={() => handleDelete(row.id)}
//                       className="text-red-500 hover:text-red-600 ml-2"
//                     >
//                       <RiDeleteBin5Line className="text-3xl" />
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan="5"
//                   className="px-4 py-2 text-center text-gray-500 border-b"
//                 >
//                   No data found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       <div className="flex justify-between items-center mt-4">
//         <div className="text-sm text-gray-600">
//           <span>Showing </span><span>1</span><span> to </span><span>5</span><span> of </span><span>2</span><span> entries</span>
//         </div>

//         {/* Pagination Controls */}
//         {entriesPerPage !== "All" && (
//           <div className="flex items-center">
//             <button
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//               className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
//             >
//               Previous
//             </button>
//             {[...Array(totalPages).keys()].map((page) => (
//               <button
//                 key={page + 1}
//                 onClick={() => handlePageChange(page + 1)}
//                 className={`px-4 py-2 border ${currentPage === page + 1
//                   ? "bg-blue-500 text-white"
//                   : "bg-gray-200 hover:bg-gray-300"
//                   }`}
//               >
//                 {page + 1}
//               </button>
//             ))}
//             <button
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//               className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </div>

//     </div>

//   );
// }

// export default Emlsms;